import { Component, OnInit } from '@angular/core';
import { Duyuru } from 'src/model/duyuru';
import { DuyuruListDTO } from 'src/model/duyuru-list-dto';
import { RestService } from 'src/providers/rest.service';

@Component({
  selector: 'app-duyurular',
  templateUrl: './duyurular.component.html',
  styleUrls: ['./duyurular.component.css']
})
export class DuyurularComponent implements OnInit {

  constructor(private restService: RestService) { }


  userId: number | undefined;
  duyurular: DuyuruListDTO[] | undefined;


  duyuru: Duyuru;

  ngOnInit(): void {
    var localUser = JSON.parse(localStorage.getItem("user"));
    if (localUser !== undefined && localUser !== null) {
      this.userId = localUser.id;
      this.getDuyurular();
    }
  }

  getDuyurular() {
    this.restService.getAllDuyuru(this.userId).subscribe(req => {
      this.duyurular = req
    });
  }

  openModel(data){
    document.getElementById("modal").style.display = "block";
    document.getElementById("modalBaslik").innerHTML = data.duyuru.baslik;
    document.getElementById("modalBody").innerHTML = data.duyuru.mesaj;
    this.restService.setDuyuruGoruldu(this.userId, data.duyuru.id).subscribe(req => {
      console.log(req);
    });

  }

  modalClose(){
    document.getElementById("modal").style.display = "none";
    this.getDuyurular();
  }


  

}
